import { jsx as _jsx } from "react/jsx-runtime";
import { createStyles, LinearProgress, withStyles, } from '@material-ui/core';
const styles = createStyles({
    root: {
        height: ({ thickness }) => (thickness ? thickness : 5),
        borderRadius: 4,
    },
    colorPrimary: {
        backgroundColor: 'var(--goto-ui-05)',
    },
    bar: {
        borderRadius: 4,
        backgroundColor: ({ coloring }) => coloring ? `var(${coloring})` : 'var(--goto-information-01)',
    },
});
const Bar = withStyles(styles)((props) => (_jsx(LinearProgress, Object.assign({}, props), void 0)));
export default Bar;
//# sourceMappingURL=Bar.js.map